import { Box, BoxProps, Stack } from '@mui/material'
import { FC } from 'react'
import { FaFacebookF as FacebookIcon } from 'react-icons/fa'
import { FcGoogle as GoogleIcon } from 'react-icons/fc'

import { Paragraph, SocialButton } from './styles'

interface ISocialLoginProps extends BoxProps {
  googleSignIn: () => Promise<void>
  facebookSignIn: () => Promise<void>
  signInText?: string
}

const SocialLogin: FC<ISocialLoginProps> = ({ googleSignIn, facebookSignIn, signInText, ...boxProps }) => (
  <Box {...boxProps}>
    {signInText && <Paragraph marginBottom={2}>{signInText}</Paragraph>}

    <Stack direction="row" spacing={4.5} justifyContent="space-between">
      <SocialButton
        fullWidth
        size="large"
        variant="contained"
        className="social-button"
        onClick={facebookSignIn}
        style={{ backgroundColor: '#0079c2' }}
      >
        <FacebookIcon color="white" size={24} />
      </SocialButton>

      <SocialButton
        fullWidth
        size="large"
        variant="contained"
        className="social-button"
        onClick={googleSignIn}
        style={{ backgroundColor: 'white' }}
      >
        <GoogleIcon size={24} />
      </SocialButton>
    </Stack>
  </Box>
)

export default SocialLogin
